import React from "react";
import {
  BaseQuadrantProps,
  calculatePercentageCounts,
  DEFAULT_HEIGHT,
  DEFAULT_WIDTH,
  getCountsByQuadrant,
  getTopQuadrantIndex,
  UserIcon,
} from "../shared";
import "./style.scss";

interface QuadrantTotalProps
  extends Omit<
    BaseQuadrantProps,
    "quadrantSidePanelTexts" | "quadrantSidePanelTitles"
  > {}

export const QuadrantTotal: React.FC<QuadrantTotalProps> = ({
  points,
  width = DEFAULT_WIDTH,
  height = DEFAULT_HEIGHT,
  yTopTitle,
  yCenterTitle,
  yBottomTitle,
  xLeftTitle,
  xCenterTitle,
  xRightTitle,
}) => {
  const countsByQuadrant = getCountsByQuadrant(points);
  const percentagesByQuadrant = calculatePercentageCounts(countsByQuadrant);
  const topQuadrantIndex = getTopQuadrantIndex(countsByQuadrant);

  return (
    <div className="quadrant-total-container">
      <div className="quadrant-total">
        <div
          className="chart-area"
          style={{
            width: `${width}px`,
            height: `${height}px`,
          }}
        >
          {percentagesByQuadrant.map((percentage, index) => (
            <div
              key={index}
              className={`quadrant with-count q${index + 1} ${
                index === topQuadrantIndex ? "active" : ""
              }`}
            >
              <div className="quadrant-count">
                {percentage}%
                <UserIcon />
              </div>
            </div>
          ))}
          <div className="axis-labels">
            <div className="y-labels">
              <div className="axis-label y-label start">{yTopTitle}</div>
              <div className="axis-label y-label center">{yCenterTitle}</div>
              <div className="axis-label y-label end">{yBottomTitle}</div>
            </div>
            <div className="x-labels">
              <div className="axis-label x-label start">{xLeftTitle}</div>
              <div className="axis-label x-label center">{xCenterTitle}</div>
              <div className="axis-label x-label end">{xRightTitle}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
